import type { PropsWithChildren } from 'react';

import clsx from 'clsx';

import { COLORS } from '~/src/common/theme';
import { isColor } from '~/src/common/utils/guards';

import styles from './Tag.module.scss';

type Props = PropsWithChildren<{
  bgColor?: string;
  fgColor?: string;
  className?: string;
}>;

const getColor = (color: string) => (isColor(color) ? COLORS[color] : color);

export const Tag = ({
  children,
  className,
  fgColor = 'NEUTRAL_DEFAULT',
  bgColor = 'GROUND_UNDERGROUNDLIGHT',
}: Props) => (
  <div
    className={clsx(styles.container, className)}
    style={{ color: getColor(fgColor), backgroundColor: getColor(bgColor) }}>
    {children}
  </div>
);
